import React, { Component } from 'react';
import './Header.css';
import Menu from "./Menu";
import { Link } from 'react-router-dom';

class Header extends Component {
    render() {
        return (
            <div className="header_container">
                <Link to={'/accueil/1'} className="header-logo">
                    <span className="header-title">un</span>
                    <span className="header-title">zeste</span>
                    <span className="header-title">de</span>
                    <span className="header-title">gourmandises</span>
                </Link>
                <Menu/>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js